import { useEffect } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'
import { toast, useToasts } from '../../state/toasts'
import { setServiceWorkerRegistration } from './swRegistration'

const UPDATE_TOAST_ID = -100

/** Shows "Update available — Reload" when a new service worker is waiting. */
export function UpdatePrompt() {
  const {
    needRefresh: [needRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_url, registration) {
      if (registration) setServiceWorkerRegistration(registration)
    },
    onRegisterError(error) {
      console.warn('service worker registration failed', error)
    },
  })

  useEffect(() => {
    if (!needRefresh) {
      useToasts.getState().dismiss(UPDATE_TOAST_ID)
      return
    }
    toast('Update available', {
      key: UPDATE_TOAST_ID,
      duration: 0,
      action: { label: 'Reload', onClick: () => void updateServiceWorker(true) },
    })
  }, [needRefresh, updateServiceWorker])

  return null
}
